import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Card, Form, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Sidebar from '../Components/Siderbar'; 
const UpdateProduct = () => {
    const { vendorName, productId } = useParams(); 
    const navigate = useNavigate();
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const AuthorizationToken = localStorage.getItem('token');
    const [product, setProduct] = useState(null);
    const [updatedProduct, setUpdatedProduct] = useState({
        productName: '',
        productType: '',
        categoryName: '',
        measurement: '',
        stock: '',
        buyingPrice: '',
        sellingPrice: '',
        aboutTheProduct: '',
        benefits: '',
        storageAndUse: '',
        productWeightOptions: []
    });

    useEffect(() => {
        fetchProductDetails();
    }, []);

    const fetchProductDetails = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/products/api/productDetails/${vendorName}/${productId}`,
                {
                    headers: {
                        Authorization: `Bearer ${AuthorizationToken}`,
                      },
                    }
            );
            setProduct(response.data);
            setUpdatedProduct({
                productName: response.data.productName || '',
                productType: response.data.productType || '',
                categoryName: response.data.categoryName || '',
                measurement: response.data.measurement || '',
                stock: response.data.stock || '',
                buyingPrice: response.data.buyingPrice || '',
                sellingPrice: response.data.sellingPrice || '',
                aboutTheProduct: response.data.aboutTheProduct || '',
                benefits: response.data.benefits || '',
                storageAndUse: response.data.storageAndUse || '',
                productWeightOptions: response.data.productWeightOptions || []
            });
        } catch (error) {
            console.error('Error fetching product:', error);
            toast.error('Error fetching product details.');
        }
    };

    const handleUpdateChange = (e) => {
        const { name, value } = e.target;
        setUpdatedProduct((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleUpdateProduct = async () => {
        try {
           await axios.put(
                `${BASE_URL}/products/api/productDetails/${vendorName}/${productId}/update`,
                updatedProduct,
                {
                    headers: {
                        Authorization: `Bearer ${AuthorizationToken}`,
                      },
                    }
            );
            toast.success('Product updated successfully!');
            navigate(`/viewProducts`);
        } catch (error) {
            console.error('Error updating product:', error);
            toast.error('Error updating product.');
        }
    };

    return (
        <div className="container-fluid">
            <Row>
                <Col md={3} className="">
                    <Sidebar />
                </Col>
                <Col md={9}>
                    <h2>Edit Product - {vendorName} / {productId}</h2>
                    <hr />
                    {product ? (
                        <Card>
                            <Card.Body>
                                <Form>
                                    <Row className="mb-3">
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>Product Name</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter product name"
                                                    name="productName"
                                                    value={updatedProduct.productName}
                                                    onChange={handleUpdateChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>Product Type</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter product type"
                                                    name="productType"
                                                    value={updatedProduct.productType}
                                                    onChange={handleUpdateChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>Category</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter category"
                                                    name="categoryName"
                                                    value={updatedProduct.categoryName}
                                                    onChange={handleUpdateChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>Measurement</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter measurement"
                                                    name="measurement"
                                                    value={updatedProduct.measurement}
                                                    onChange={handleUpdateChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>About the Product</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    name="aboutTheProduct"
                                                    value={updatedProduct.aboutTheProduct}
                                                    onChange={handleUpdateChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>Benefits</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    name="benefits"
                                                    value={updatedProduct.benefits}
                                                    onChange={handleUpdateChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>Storage and Use</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    name="storageAndUse"
                                                    value={updatedProduct.storageAndUse}
                                                    onChange={handleUpdateChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <div className="mt-3">
                                        <Button variant="success" onClick={handleUpdateProduct}>
                                            Save Changes
                                        </Button>
                                    </div>
                                </Form>
                            </Card.Body>
                        </Card>
                    ) : (
                        <div>Loading product details...</div>
                    )}
                </Col>
            </Row>
        </div>
    );
};

export default UpdateProduct;
